import {BaseContainerModel} from '../base-container.model';
import {bl_mrp_process_instance_hdr_RowClass} from '../../dbschema/bl_mrp_process_instance_hdr.model';
import {bl_mrp_process_instance_line_RowClass} from '../../dbschema/bl_mrp_process_instance_line.model';
import { bl_mrp_pi_worklog_Rowclass, bl_mrp_process_instance_ext_RowClass } from '../../dbschema';

export class MrpProcessInstanceContainerModel extends BaseContainerModel {
  bl_mrp_process_instance_hdr:  bl_mrp_process_instance_hdr_RowClass = new  bl_mrp_process_instance_hdr_RowClass();
  bl_mrp_pi_worklogs: bl_mrp_pi_worklog_Rowclass[] = [];
  bl_mrp_process_instance_lines: bl_mrp_process_instance_line_RowClass[] = [];
  bl_mrp_process_instance_exts: bl_mrp_process_instance_ext_RowClass[] = [];
}
